import { Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./App.css";
import Home from "./components/Home";
// import Register from "./components/Register";
import Login from "./components/Login";
import Error from "./services/Error";
import Footer from "./components/Footer";
import Tasks from "./components/Tasks";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import { AuthState } from "./services/Context";
import Stats from "./components/Stats";
import AddTask from "./components/AddTask";
import Register from "./components/Register";
import Welcome from "./components/Welcome";

function App() {
  const [userLoginState, setUserLoginState] = useState(false);
  const [submitState, setSubmitState] = useState(false);

  const token = localStorage.getItem("login_token");

  useEffect(() => {
    if (!token) {
      setUserLoginState(false);
    } else {
      setUserLoginState(true);
    }
  }, [token]);

  return (
    <div className="App">
      <div>
        <main>
          <AuthState.Provider value={{ userLoginState, setUserLoginState, submitState, setSubmitState }}>
            <Header />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/add" element={<AddTask />} />
              <Route path="/login" element={<Login />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/register" element={<Register />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/confirm" element={<Welcome/>} />
              {/* <Route path="/gifts" element={<UserGifts />} />
              <Route path="/reserved" element={<ReservedGifts />} />
              <Route path="/users" element={<AllUsers />} />
              <Route path="/addgift" element={<AddGift />} />
              <Route path="/contribute/:id" element={<Contribute />} /> */}
              <Route path="*" element={<Error />} />
            </Routes>
            <Footer />
          </AuthState.Provider>
        </main>
      </div>
    </div>
  );
}

export default App;
